let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d2yHi")).then(() => parcelRequire('1r33K'));